module.exports = __webpack_public_path__ + "img/icon-number-four.6c6ad13c.svg";